import { Navigate, useLocation } from "react-router";
import { renamedPath } from "./renamed-paths";

/** Sends a moved address to its new one, keeping the rest of the path, the query and the hash (ADR 0069). */
export function RenamedPath({ from, to }: { readonly from: string; readonly to: string }) {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={{ pathname: renamedPath(pathname, from, to), search, hash }} replace />;
}
